
// Order is important here. EmbedApp before React and react-dom
import { EmbedApp } from 'media-embed-app'; // eslint-disable-line import/no-extraneous-dependencies
import React from 'react';
import { render } from 'react-dom';
import { Apm } from 'web-media-apm';


const apmConfig = window.mediaConfig.embed.apm;
const webMediaApm = new Apm(apmConfig);

render(
    <EmbedApp
        list={window.dataBootstrap.list}
        requestParams={window.requestParams}
        initialMedia={window.initialMedia}
        mediaConfig={window.mediaConfig}
        webMediaApm={webMediaApm}
    />,
    document.getElementById('root')
);
